import './App.css';
import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Terms from './Terms';
import QuestionSent from './QuestionSent';

const theme = createTheme({
  palette: {
    primary: {
      main: '#005D00',
    },
  },
});

function App() {
  const [question, setQuestion] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [joinNewsletter, setJoinNewsletter] = useState(false);
  const [publishName, setPublishName] = useState(false);
  const [over16, setOver16] = useState(false);
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [questionErr, setQuestionErr] = useState(false);
  const [nameErr, setNameErr] = useState(false);
  const [emailErr, setEmailErr] = useState(false);
  const [questionSent, setQuestionSent] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);

  const handleQuestionChange = (event) => { setQuestion(event.target.value); };
  const handleNameChange = (event) => { setName(event.target.value); };
  const handleEmailChange = (event) => { setEmail(event.target.value); };
  const handleJoinNewsletterChange = (event) => { setJoinNewsletter(event.target.checked); };
  const handlePublishNameChange = (event) => { setPublishName(event.target.checked); };
  const handleOver16Change = (event) => { setOver16(event.target.checked); };
  const handleAgreeTermsChange = (event) => { setAgreeTerms(event.target.checked); };
  const handleTermsOpen = () => { setTermsOpen(true); };
  const handleTermsClose = () => { setTermsOpen(false); };

  const handleSubmission = async () => {
    setQuestionErr(question === '');
    setNameErr(name === '');
    setEmailErr(email === '');
    if (question !== '' && name !== '' && email !== '' && over16 && agreeTerms) {
      const url = "https://api.trello.com/1/cards";
      const formData = new FormData();
      formData.append("name", question);
      formData.append("desc",
        "Name: " + name + "\n\n" +
        "Email: " + email + "\n\n\n" +
        "Sign up for newsletter: " + (joinNewsletter ? "Yes" : "No") + "\n\n" +
        "Publish my name: " + (publishName ? "Yes" : "No") + "\n\n" +
        "Over 16 years old: " + (over16 ? "Yes" : "No") + "\n\n" +
        "Agree to Terms: " + (agreeTerms ? "Yes" : "No")
      );
      formData.append("idList", "5f0d1fad57437d111a47a979");
      formData.append("key", "d214d877ca8e63be06d7f00b009a62bb");
      formData.append("token", "ATTAf525f75ebd0dccdcad6b50497d57c9c0841607095808244e1863b1aef9010e9a95B36F1A");
      try {
        const response = await fetch(url, {
          method: "POST",
          body: formData,
        });
        const data = await response.json();
        console.log(data);
      } catch (error) {
        console.log("There was a problem with the fetch operation:", error);
      }
      setQuestionSent(true);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="flex justify-center">
        <div className="frame relative pb-8">
          { questionSent && <QuestionSent /> }
          { (!questionSent && termsOpen) && <Terms close={handleTermsClose} /> }
          { !questionSent &&
            <>
              <div className="flex justify-center">
                <img className="logo" src="logo_new.png" />
              </div>
              <div className="question_holder flex justify-center">
                <TextField
                  error={questionErr}
                  helperText={questionErr ? "This field is required." : ""}
                  color="primary"
                  id="question_area"
                  label="Question *"
                  placeholder="What do you want to know about UNL, its culture, or its people?"
                  multiline
                  rows={4}
                  onChange={handleQuestionChange}
                />
              </div>
              <div className="contacttxt_holder">
                <p className="contact_info">CONTACT INFORMATION</p>
                <p className="contact_desc">We may be in touch when we look into your question.</p>
              </div>
              <div className="name_holder flex justify-center">
                <TextField
                  error={nameErr}
                  helperText={nameErr ? "This field is required." : ""}
                  id="name_area"
                  label="Name *" 
                  variant="outlined" 
                  onChange={handleNameChange} 
                />
              </div>
              <div className="email_holder flex justify-center">
                <TextField 
                  error={emailErr}
                  helperText={emailErr ? "This field is required." : ""}
                  id="email_area" 
                  label="Email *" 
                  variant="outlined" 
                  onChange={handleEmailChange} 
                />
              </div>
              <div className="checks_holder">
                <FormControlLabel
                  id="join_newsletter"
                  control={<Checkbox checked={joinNewsletter} onChange={handleJoinNewsletterChange} />}
                  label="Sign me up for your newsletter!"
                />
                <FormControlLabel
                  id="publish_name"
                  control={<Checkbox checked={publishName} onChange={handlePublishNameChange} />}
                  label="Please don't publish my name"
                />
                <FormControlLabel
                  id="over_16"
                  control={<Checkbox checked={over16} onChange={handleOver16Change} />}
                  label="I am over 16 years old"
                />
                <FormControlLabel
                  id="agree_terms"
                  control={<Checkbox checked={agreeTerms} onChange={handleAgreeTermsChange} />}
                  label={
                    <span>
                      I agree to the&nbsp;
                      <span id="terms" onClick={handleTermsOpen}>Terms of Service</span>
                    </span>
                  }
                />
              </div>
              <div className="flex justify-center">
                <Button
                  id="submit"
                  variant="contained"
                  onClick={handleSubmission}
                >
                  Submit
                </Button>
              </div>
            </>
          }
        </div>
      </div>
    </ThemeProvider>
  );
}

export default App;
